import React from "react";
import PropTypes from "prop-types";
import BackButton from "../BackButton";
import ExitGameButton from "../ExitGameButton";
import BaseMobileHeader from "../BaseMobileHeader";
import BurgerMenu from "../BurgerMenu";
import useAuth from "../../hooks/useAuth";
import "./style.scss";
import NavigateToLoginBtn from "../NavigatoToLoginBtn/NavigateToLoginBtn";

export default function WrapperPage({
  children,
  headerTitle,
  exitGameBtn,
  burgerMenu,
  backBtn,
  onClickBackBtn,
  loginBtn,
}) {
  WrapperPage.propTypes = {
    children: PropTypes.node,
    onClickBackBtn: PropTypes.func,
    headerTitle: PropTypes.string,
    exitGameBtn: PropTypes.bool,
    backBtn: PropTypes.bool,
    burgerMenu: PropTypes.bool,
    loginBtn: PropTypes.bool,
  };
  const { token } = useAuth();
  return (
    <div className="base-page-wrapper">
      <BaseMobileHeader
        isBtnExitGame={exitGameBtn}
        isBackBtn={backBtn}
        isBurgerMenu={burgerMenu}
        loginBtn={loginBtn}
        onClickBackBtn={onClickBackBtn}
      />
      <div
        style={{
          justifyContent:
            !exitGameBtn && !backBtn ? "flex-end" : "space-between",
        }}
        className="base-page-wrapper__header"
      >
        {exitGameBtn && <ExitGameButton />}
        {backBtn && <BackButton onClick={onClickBackBtn} />}
        {burgerMenu && token ? (
          <BurgerMenu className="base-page-wrapper__burger-menu" />
        ) : null}
        {loginBtn ? <NavigateToLoginBtn /> : null}
      </div>
      {headerTitle && (
        <div
          className="base-page-wrapper__title neon-text"
          data-text={headerTitle}
        >
          {headerTitle}
        </div>
      )}
      {children}
    </div>
  );
}
